import { cn } from '../lib/cn';
// Dark/ink wordmark for light surfaces; white-and-lime wordmark for dark ones.
import logoDark from '../assets/brand/logo-dark.png';
import logoLight from '../assets/brand/logo-light.png';

export interface LogoProps {
  /** Retained for API compatibility — the lockup always includes the wordmark. */
  wordmark?: boolean;
  /** Render for a dark surface (sidebar, hero) — uses the white + lime lockup. */
  onDark?: boolean;
  className?: string;
}

/** The TechSoFit wordmark lockup. Picks the dark or light artwork by background. */
export function Logo({ onDark = false, className }: LogoProps) {
  return (
    <img
      src={onDark ? logoLight : logoDark}
      alt="TechSoFit"
      className={cn('h-7 w-auto select-none', className)}
      draggable={false}
    />
  );
}
